const bookingHelper = {
  apiDetails(id: number) {
    return `/dashboard-api/reception/booking/${id}/`
  },
  changeDate(id: number) {
    return `/dashboard-api/rent/booking/change-date/${id}/`
  },
  changeApartment(id: number) {
    return `/dashboard-api/rent/booking/change-apartment/${id}/`
  },
  deleteBlockApartment(id: number) {
    return `/dashboard-api/rent/booking/delete-block-apartment/${id}/`
  },
  details(id?: number) {
    if (!id) {
      return ''
    }
    return `/admin/rent/booking/${id}/change/`
  },
  extendedStay(id: number, apartmentId?: number) {
    if (apartmentId == null) {
      return ''
    }

    return `/dashboard-api/reception/booking-extended-stay/${id}/${apartmentId}/`
  },
  confirmCheckIn(id: number) {
    return `/dashboard-api/reception/booking/${id}/confirm-checkin-online-start/`
  },
  reservationCollision(id: number) {
    return `/dashboard-api/reservation/reservation/${id}/collision/`
  },
  checkOutValidate(id: number) {
    return `/dashboard-api/reception/booking/${id}/check-out/validate/`
  },
} as const

export default bookingHelper
